// extracted by mini-css-extract-plugin
module.exports = {"card-link":"ProductCard_card-link__xBcN7"};